import { tx, mdDow } from '../../../lib/adminI18n';
// 清掃管理の共通の型・補助関数（手順5）
export interface Assignee { id: number; name: string; is_lead: number; is_active: number; }
export interface TaskRow {
  id: number; property_id: string; property_name: string | null;
  booking_prefix: string | null; abbreviation: string | null;
  cleaning_date: string; checkin_date: string | null;
  status: string; source: string; reservation_id: string | null; note: string | null;
  planned_start_at?: string | null; planned_end_at?: string | null;
  actual_start_at?: string | null; actual_end_at?: string | null;
  reported_at?: string | null; report_note?: string | null; issue_reason?: string | null;
  supply_cost?: number | null; admin_checked_at?: string | null;
  review_status?: 'approved' | 'rejected' | null; reviewed_at?: string | null;
  assignees?: Assignee[];
  photo_count?: number;   // 清掃者が報告した写真の枚数（2026-10-29）
}
export interface PropertyOpt { id: string; name: string; }
export interface CleanerOpt { id: number; name: string; is_active: number; }

export const STATUS_LABEL: Record<string, string> = {
  get pending() { return tx('cln.stPending'); },
  get in_progress() { return tx('cln.stProgress'); },
  get completed() { return tx('cln.stDone'); },
  get needs_review() { return tx('cln.stReview'); },
  get cancelled() { return tx('cln.stCancelled'); },
};

// JST の今日 'YYYY-MM-DD'（日本は DST なし）
export function jstToday(): string {
  return new Date(Date.now() + 9 * 3600e3).toISOString().slice(0, 10);
}
export function addDays(ymd: string, n: number): string {
  const d = new Date(ymd + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
export function mondayOf(ymd: string): string {
  const dow = (new Date(ymd + 'T00:00:00Z').getUTCDay() + 6) % 7;
  return addDays(ymd, -dow);
}
export function monthFirst(ymd: string, offset = 0): string {
  const d = new Date(ymd.slice(0, 7) + '-01T00:00:00Z');
  d.setUTCMonth(d.getUTCMonth() + offset);
  return d.toISOString().slice(0, 10);
}
// '2026-10-28' → '10/28(水)'
export function dateLabel(ymd: string): string {
  return mdDow(ymd);
}
// UTC ISO → JST 'HH:MM'（日付が清掃日と違えば 'MM/DD HH:MM'）
export function jstTime(iso?: string | null, baseYmd?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const j = new Date(d.getTime() + 9 * 3600e3).toISOString();
  const hm = j.slice(11, 16);
  return baseYmd && j.slice(0, 10) !== baseYmd ? `${j.slice(5, 7)}/${j.slice(8, 10)} ${hm}` : hm;
}
// 予定時刻（JST 'YYYY-MM-DDTHH:MM'）→ 'HH:MM'
export function plannedRange(t: TaskRow): string {
  const a = t.planned_start_at ? t.planned_start_at.slice(11, 16) : '';
  const b = t.planned_end_at ? t.planned_end_at.slice(11, 16) : '';
  return a || b ? `${a || '—'}〜${b || '—'}` : '—';
}
export function propertyLabel(t: TaskRow): string {
  return t.property_name || t.property_id;
}
export async function getJson(url: string, init?: RequestInit): Promise<any> {
  const res = await fetch(url, { credentials: 'include', ...(init || {}) });
  const data = await res.json().catch(() => ({} as any));
  if (!res.ok) throw new Error(data?.error || tx('cln.err', { s: res.status }));
  return data;
}
